import React from 'react';
import Input from '../../../Components/Input';
import DimensionSelector from '../DimensionSelector';
import TypographySelector from '../TypographySelector';
import PositionSelector from '../PositionSelector';
import { BuilderActionType, BuilderContext } from '../state';
import VendexElement, { VendexInputMeta } from '../../../Model/VendexElement';

type Props = {
    element: VendexElement;
};

function InputDetail({ element }: Props) {
    const data = element.metaData as VendexInputMeta;

    const { dispatch } = React.useContext(BuilderContext);

    const handleChange = (value: VendexElement) => {
        dispatch({
            type: BuilderActionType.UPDATE_ELEMENT,
            payload: value,
        });
    };

    const handleDataChange = (name: string, value: string) => {
        handleChange({
            ...element,
            metaData: { ...data, [name]: value },
        });
    };

    return (
        <>
            <div className="flex gap-3 mb-3">
                <p className="w-40 font-semibold">Name*</p>
                <Input
                    onChange={(e) => {
                        handleDataChange('name', e.target.value);
                    }}
                    value={data.name}
                />
            </div>
            <div className="flex gap-3 mb-3">
                <p className="w-40 font-semibold">Type</p>
                <select
                    onChange={(e) => {
                        handleDataChange('type', e.target.value);
                    }}
                    value={data.type}
                >
                    <option value="text">text</option>
                    <option value="number">number</option>
                    <option value="date">date</option>
                    <option value="password">password</option>
                </select>
            </div>
            <div className="flex gap-3 mb-3">
                <p className="w-40 font-semibold">Placeholder</p>
                <Input
                    onChange={(e) => {
                        handleDataChange('placeholder', e.target.value);
                    }}
                    value={data.placeholder ? data.placeholder : ''}
                />
            </div>
            <TypographySelector
                selector={`#${element.id}`}
                hasAlignment={false}
            />
            <PositionSelector selector={`#${element.id}`} />
            <DimensionSelector selector={`#${element.id}`} />
        </>
    );
}

export default InputDetail;
